export enum OperatorType {
  addition = '+',
  subtraction = '-',
  multiplication = '*',
  mod = '%',
  division = '/',
  integerDivision = '//'
}
